import styled from 'styled-components';
import { IDefaultButton } from './interface';

export const defaultButton = styled.button<IDefaultButton>`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  grid-area: ${(props) => (props.gridArea ? props.gridArea : '')};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'center'};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'row'};
  color: #ffffff;
  font-size: 1rem;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  margin: ${(props) => (props.margin ? props.margin : '0.25rem')};
  border: none;
  background-color: ${(props) => {
    if (props.wasClicked) {
      return props.theme.colors.hover;
    }
    return props.backgroundColor
      ? props.backgroundColor
      : props.theme.colors.mainColor;
  }};
  height: ${(props) => (props.height ? props.height : '2.5rem')};
  width: ${(props) => (props.width ? props.width : 'auto')};

  &:hover {
    background-color: ${(props) => props.theme.colors.hover};
    transition-duration: 150ms;
    cursor: pointer;
  }
  &[disabled] {
    background-color: ${(props) => props.theme.colors.hover}44;
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }
`;

const Button = {
  Default: defaultButton,
};

export default Button;
